import { render, staticRenderFns } from "./PassDialog.vue?vue&type=template&id=1c1450e5&scoped=true"
import script from "./PassDialog.vue?vue&type=script&lang=js"
export * from "./PassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1450e5",
  null
  
)

export default component.exports